import { IContentfulFilters, fetchEntries } from 'api/contentful/fetchEntries';
import { Entry, EntryCollection } from 'contentful';
import { FlatEntry, flattenContentfulData } from 'services/cms/flattenContentful';
import { isValidLocale } from 'utils/Locales';

export const CONTENTFUL_REQUEST_LIMIT = 200;

export async function fetchFlatEntries<T extends object>(language: string, filter: IContentfulFilters) {
  if (!isValidLocale(language)) return;

  let items: Array<Entry<T>> = [];
  let currentPage = 0;
  let totalNumPages = -1;

  do {
    const fetchedCollection = (await fetchEntries<T>(language, {
      ...filter,
      limit: CONTENTFUL_REQUEST_LIMIT,
      skip: currentPage * CONTENTFUL_REQUEST_LIMIT,
    })) as EntryCollection<T>;

    totalNumPages = fetchedCollection.total;
    currentPage++;
    items = [...items, ...fetchedCollection.items];
  } while (items.length < totalNumPages);

  return items.map(flattenContentfulData).filter(Boolean) as FlatEntry<T>[];
}
